import React, { memo } from 'react';
import styled from 'styled-components';
import { Button, Row, Col } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { HelpCenterLinkComponent } from 'Common/Components/TablePanel';

const HeaderRow = styled(Row)`
  padding: 1em 1em 0 1em;
  margin-bottom: 1em;
`;

const HeaderCol = styled(Col)`
  display: flex;
  align-items: center;
`;

const H2Header = styled.h2`
  line-height: 1.2em;
  font-size: 1.2em;
`;

const DownloadButton = styled(Button)`
  border: none;
  background: none !important;
  box-shadow: none !important;
  border-color: transparent !important;
  border-style: none;
  --antd-wave-shadow-color: transparent !important;
`;

interface Props {
  title: string;
  handleDownload?: () => void;
  downloadInProgress?: boolean;
  isDisabled?: boolean;
  helpCenterLink: string;
}
const DownloadIcon = styled(DownloadOutlined)`
  font-size: 18px;
`;

const EmployeeReportHeader: React.FC<Props> = ({
  title,
  downloadInProgress,
  isDisabled,
  handleDownload,
  helpCenterLink,
}) => (
  <HeaderRow>
    <HeaderCol span={12}>
      <H2Header>{title}</H2Header>
    </HeaderCol>

    <HeaderCol
      css={`
        justify-content: flex-end;
      `}
      span={12}
    >
      {helpCenterLink !== undefined && (
        <HelpCenterLinkComponent
          url={helpCenterLink}
          style={{
            marginRight: '10px',
            fontSize: '18px',
            textDecoration: 'none',
          }}
        />
      )}

      <DownloadButton
        icon={<DownloadIcon />}
        onClick={handleDownload}
        loading={downloadInProgress}
        disabled={isDisabled}
        data-testid="download"
      />
    </HeaderCol>
  </HeaderRow>
);

export default memo(EmployeeReportHeader);
